import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/logout")({
  component: LogoutPage,
});

function LogoutPage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-6 text-center">
        <div className="flex flex-col gap-2">
          <h1 className="text-xl font-semibold tracking-tight">Signed out</h1>
          <p className="text-muted-foreground">
            You have been signed out successfully.
            <br />
            It is safe to close this page.
          </p>
        </div>
        <a
          href="/login"
          className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex h-9 items-center justify-center rounded-md px-4 text-sm font-medium shadow"
        >
          Sign in again
        </a>
      </div>
    </div>
  );
}
